module.exports = __webpack_public_path__ + "static/media/menu.e3bbf806.svg";